import { Action, createReducer, on } from '@ngrx/store';
import { IPMessage } from '../../models/pmessage.model';
import { mainActions } from './main.actions';
import { BootstrapOptions, LOCALE_ID } from '@angular/core';
import { ILoaderActionPayload, LoadingState } from '../models/loader.model';
import { Cols } from '../../models/paginated.component';

export interface MainState {
  messages: {
    main?: IPMessage;
  };
  ui: {
    usersList: {
      advSearch: boolean;
    };

    alertList: {
      advSearch: boolean;
    };
    pickerPrinterModalList: {
      advSearch: boolean;
    };
    printersList: {
      advSearch: boolean;
    };
    snmpVaultsList: {
      advSearch: boolean;
    };
    printersModelList: {
      advSearch: boolean;
    };
    agentsList: {
      advSearch: boolean;
    };
    emailEventList: {
      advSearch: boolean;
    };
    emailReportList: {
      advSearch: boolean;
    };
    batchPickerPrinterModalList: {
      advSearch: boolean;
    };
    loacalColumns: {
      cols: Cols[];
    };
  };
}

const initialState: MainState = {
  messages: {},
  ui: {
    usersList: {
      advSearch: false,
    },
    alertList: {
      advSearch: false,
    },
    pickerPrinterModalList: {
      advSearch: false,
    },
    printersList: {
      advSearch: false,
    },
    agentsList: {
      advSearch: false,
    },
    printersModelList: {
      advSearch: false,
    },
    snmpVaultsList: {
      advSearch: false,
    },
    emailEventList: {
      advSearch: false,
    },
    emailReportList: {
      advSearch: false,
    },
    batchPickerPrinterModalList: {
      advSearch: false,
    },
    loacalColumns: {
      cols: [],
    },
  },
};

const reducer = createReducer(
  initialState,
  on(mainActions.createMainMessage, (state, action) => ({
    ...state,
    messages: { ...state.messages, main: action.message },
  })),

  on(mainActions.uiUsersListAdvSearch, (state, action) => ({
    ...state,
    ui: { ...state.ui, usersList: { advSearch: action.value } },
  })),
  on(mainActions.uiAlertListAdvSearch, (state, action) => ({
    ...state,
    ui: { ...state.ui, alertList: { advSearch: action.value } },
  })),

  on(mainActions.uiPickerPrinterModalListAdvSearch, (state, action) => ({
    ...state,
    ui: { ...state.ui, pickerPrinterModalList: { advSearch: action.value } },
  })),
  on(mainActions.uiAgentsAdvSearch, (state, action) => ({
    ...state,
    ui: { ...state.ui, agentsList: { advSearch: action.value } },
  })),
  on(mainActions.uiPrinterListAdvSearch, (state, action) => ({
    ...state,
    ui: { ...state.ui, printersList: { advSearch: action.value } },
  })),
  on(mainActions.uiSnmpVAultAdvSearch, (state, action) => ({
    ...state,
    ui: { ...state.ui, snmpVaultsList: { advSearch: action.value } },
  })),
  on(mainActions.uiPritnersModelsAdvSearch, (state, action) => ({
    ...state,
    ui: { ...state.ui, printersModelList: { advSearch: action.value } },
  })),
  on(mainActions.uiEmailEventListAdvSearch, (state, action) => ({
    ...state,
    ui: { ...state.ui, emailEventList: { advSearch: action.value } },
  })),
  on(mainActions.uiEmailReportListAdvSearch, (state, action) => ({
    ...state,
    ui: { ...state.ui, emailReportList: { advSearch: action.value } },
  })),
  on(mainActions.uiBatchPickerPrinterModalListAdvSearch, (state, action) => ({
    ...state,
    ui: { ...state.ui, batchPickerPrinterModalList: { advSearch: action.value } },
  })),
  on(mainActions.loacalColumnsTake, (state, props) => {
    const dataFromLocalStorage = localStorage.getItem(props.listId);

    const cols: Cols[] = dataFromLocalStorage?.length ? JSON.parse(dataFromLocalStorage) : [];

    return {
      ...state,
      ui: { ...state.ui, loacalColumns: { cols } },
    };
  }),
);

export function mainReducer(state: MainState | undefined, action: Action) {
  return reducer(state, action);
}
